const getters = {
  menuSetting: state => state.menuSetting
}
  
export default getters